import React, { useState } from "react";

import Styled from "./DropdownStyles";
import { ArrowHeadDown, Color, FONT_FAMILY, Typography } from "../../ontego-ui";
import { OverflowMenuSelection } from "../OverflowMenuSelection/OverflowMenuSelection";

export const Dropdown = (props) => {
    const { id = "", menu = [], selected = null, backgroundColor, style, placeholder, withCheckMark = true } = props

    const [anchorEl, setAnchorEl] = useState(null);

    let defaultItem = null
    let defaultPlaceholder = ""

    if (selected) {
        defaultItem = selected
    }

    if (placeholder) {
        defaultPlaceholder = placeholder
    }

    const [selectedItem, setSelectedItem] = useState(defaultItem)

    const handleClickMenuSelection = (event) => {
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        };
    }

    return (
        <Styled.DropdownContainer
            id={id}
            aria-controls={`${id}-dropdownMenu`}
            aria-haspopup="true"
            onClick={handleClickMenuSelection}
            style={{
                background: backgroundColor,
                ...style
            }}
        >
            <Styled.DropdownText id={`${id}-dropdownText`}>
                <Typography
                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
                    size={14}
                    color={Color.neutral[400]}
                >
                    {selectedItem ? selectedItem : placeholder}
                </Typography>
            </Styled.DropdownText>
            <Styled.DropdownArrowIcon id={`${id}-dropdownArrow`}>
                <ArrowHeadDown />
            </Styled.DropdownArrowIcon>
            <OverflowMenuSelection
                id={`${id}-dropdownMenu`}
                anchorElement={anchorEl}
                menuItems={menu ? menu : []}
                setValue={setSelectedItem}
                setAnchorEl={setAnchorEl}
                selectedItem={selectedItem}
                menuWidth={style?.width}
                withCheckMark={withCheckMark ? true : false}
            />
        </Styled.DropdownContainer>
    )
}

export default React.memo(Dropdown)